import HomeTemplate from '../templates/HomeTemplate.jsx'
import FaqSection from '../components/ui/FaqSection.jsx'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'
import { useEffect, useState } from 'react'

const FAQS = [
  {
    q: 'Is FastAudio free to use?',
    a: 'Yes, FastAudio is completely free. There are no hidden fees, no registration required, and no software to install.',
  },
  {
    q: 'Which platforms are supported?',
    a: 'FastAudio supports YouTube, Instagram (Reels and posts), TikTok videos, and Facebook videos. More platforms may be added in future updates.',
  },
  {
    q: 'What audio quality can I choose?',
    a: 'You can select from 128 kbps, 192 kbps, or 320 kbps MP3. Higher bitrates produce larger files but better audio quality.',
  },
  {
    q: 'How do I convert a video to MP3?',
    a: 'Paste the video URL into the input box, choose your preferred quality, then click Convert. Your download will be ready in seconds.',
  },
  {
    q: 'Is it legal to convert videos to MP3?',
    a: 'Converting video to audio for personal, non-commercial use is generally permitted. However, you must ensure you own the rights or have permission to download the content. Downloading copyrighted material without authorisation may violate the platform\'s terms of service.',
  },
  {
    q: 'Why did my conversion fail?',
    a: 'Conversions can fail if the video is private, age-restricted, geo-blocked, or has been removed. Some platforms also restrict server-side access for certain content types.',
  },
  {
    q: 'How long does conversion take?',
    a: 'Most conversions complete in under 10 seconds. Longer videos or high-traffic periods may take slightly longer.',
  },
  {
    q: 'Do you store the converted files?',
    a: 'Converted files are held temporarily on our servers for download and are deleted automatically after a short period. We do not retain your downloads.',
  },
]

const title = `Frequently Asked Questions – ${SITE_NAME}`
const description = 'Find answers to common questions about FastAudio — supported platforms, audio quality, legality, and how to convert videos to MP3.'
const canonical = `${SITE_URL}/faqs`

export default function Faqs() {
  const [faqs, setFaqs] = useState(FAQS)
  useEffect(() => {
    fetch('/admin/api/public/faqs').then(response => response.ok ? response.json() : [])
      .then(items => {
        if (items.length) setFaqs(items.map(item => ({ q: item.question, a: item.answer.replace(/<[^>]+>/g, '') })))
      }).catch(() => {})
  }, [])
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
      badge="Help Centre"
      heading={
        <>
          Frequently Asked{' '}
          <span className="text-gradient">Questions</span>
        </>
      }
      subheading="Everything you need to know about converting videos to MP3 with FastAudio."
    >
      <FaqSection faqs={faqs} />
    </HomeTemplate>
  )
}
